import { render } from "./TestingServiceHero.vue?vue&type=template&id=2b6330a9"
import script from "./TestingServiceHero.vue?vue&type=script&lang=js"
export * from "./TestingServiceHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__